import React, {FunctionComponent, lazy, Suspense, useMemo} from 'react'
import styles from './SettingsPage.module.sass'
import {ROUTES} from '../../../../http/routes'
import {settingsRoutesMore} from '../RefPage/refs-config'
import {Route, Switch, useRouteMatch} from 'react-router'
import {PERMISSIONS} from '../../../../constants/permissions'
import {urlWithParams} from '../../../../http/utils'
import {conditionSnoc} from '../../../../utils/utils'
import {NavLink} from 'react-router-dom'
import Helmet from 'react-helmet'
import Tabs from '../../../navigation/Tabs/Tabs'
import RefEditDialog from '../RefEditDialog/RefEditDialog'
import {RefEditState, refsActions} from '../../../../redux/pages/settings/refs'
import {Dialog} from '../../../etc/Dialog/Dialog'
import OkCancel from '../../../controls/OkCancel/OkCancel'
import {useAllPermissions, useRootDispatch, useRootSelector} from '../../../../utils/hooks'
import {RefKey} from '../../../../responses/refs/refs'
import ObjectPanel from '../../../data-components/elements/ObjectPanel/ObjectPanel'
import {Colors} from '../../../../styles'

const RefPage = lazy(() => import('../RefPage/RefPage'))
const UsersPage = lazy(() => import('../UsersPage/UsersPage'))
const RolesPage = lazy(() => import('../RolesPage/RolesPage'))
const ConfigPage = lazy(() => import('../ConfigPage/ConfigPage'))
const ObjectsPage = lazy(() => import('../ObjectsPage/ObjectsPage'))
const DepartmentsPage = lazy(() => import('../DepartmentsPage/DepartmentsPage'))

const SettingsPage: FunctionComponent = () => {
    const canViewRoles = useAllPermissions([PERMISSIONS.SETTINGS.ROLE_LIST])
    const canViewConfig = useAllPermissions([PERMISSIONS.SETTINGS.CONFIG_LIST])

    /*const tabs = pipe(
        settingsRoutesMore,
        conditionSnoc(canViewRoles, {
            key: 'roles',
            name: 'Права доступа',
        }),
        conditionSnoc(canViewConfig, {
            key: 'config',
            name: 'Конфигурация',
        }),
    )*/
    const tabs = settingsRoutesMore.slice()
    conditionSnoc(canViewRoles, tabs.splice(1, 0, {
        key: 'roles',
        name: 'Права доступа',
    }))
    conditionSnoc(canViewConfig, tabs.push({
        key: 'config',
        name: 'Конфигурация',
    }))

    const keyClientBrand = (canViewRoles) ? 4 : 3
    tabs.splice(keyClientBrand, 0, {
        key: 'client',
        name: 'Клиенты/Бренды',
    })

    const dispatch = useRootDispatch()
    const editState = useRootSelector(state => state.pages.settings.refs.editState)

    const match = useRouteMatch<{ key: RefKey }>(ROUTES.SETTINGS_REF)
    const selected = useMemo(() => tabs.find(tab => {
        return tab.key === match?.params.key ||
            (
                (match?.params.key === 'direction' && tab.key === 'user') ||
                (match?.params.key === 'department' && tab.key === 'user')
            ) ||
            (
                (match?.params.key === 'brand' && tab.key === 'client')
            )
    }), [match?.params?.key, tabs])

    const tabsKeys = [
        'roles',
        'task-type',
        'client',
        'network'
    ]

    if (!canViewRoles) {
        tabsKeys.push('user')
    }

    return <div className={styles.page}>
        <Helmet titleTemplate={'Настройки - %s'}/>
        <Tabs
            className={styles.header}
            items={tabs}
            itemsKeys={tabsKeys}
            selected={selected}
            itemToKey={tab => tab.key}
            renderer={tab => <NavLink
                key={tab.key}
                to={urlWithParams({key: tab.key})(ROUTES.SETTINGS_REF)}
            >
                {tab.name}
            </NavLink>}
        />
        <Suspense fallback={null}>
            <Switch>
                <Route path={ROUTES.SETTINGS_DEPARTMENTS} component={DepartmentsPage}/>
                <Route path={ROUTES.SETTINGS_OBJECTS} component={ObjectsPage}/>
                <Route path={ROUTES.SETTINGS_CONFIG} component={ConfigPage}/>
                <Route path={ROUTES.SETTINGS_ROLES} component={RolesPage}/>
                <Route path={ROUTES.SETTINGS_USERS} component={UsersPage}/>
                <Route path={ROUTES.SETTINGS_REF} component={RefPage}/>
            </Switch>
        </Suspense>
        <RefEditDialog
            state={editState}
            onOk={changes => {
                RefEditState.match({
                    create: ({key}) => dispatch(refsActions.add.request({key, value: changes})),
                    update: ({key, ref}) => dispatch(refsActions.update.request({
                        key,
                        old: ref,
                        changes,
                    }))
                }, () => console.warn('Действие не определено'))(editState)
            }}
            onCancel={() => dispatch(refsActions.cancelEdit())}
        />
        {
            RefEditState.is.delete(editState) && <Dialog
                header={`Подтвердите удаление "${editState.ref.name}"`}
                onClose={() => dispatch(refsActions.cancelEdit())}
                actions={({onClose}) => <OkCancel
                    color={Colors.red}
                    onCancel={onClose}
                    onOk={() => dispatch(refsActions.delete.request())}
                />}
            >
                {(() => {
                    switch (editState.key) {
                        case 'work-object':
                            return <ObjectPanel object={editState.ref}/>
                        default:
                            return undefined
                    }
                })()}
            </Dialog>
        }
    </div>
}

export default SettingsPage